import type { Mutation, MutationSendCableReelMailArgs } from '@ab-core/graphql/dist';
import { useMutation } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { SEND_CABLE_REEL_MAIL } from './gql/sendCableReelMail';

type MutationDataType = Pick<Mutation, 'sendCableReelMail'>;
type ResponseDataType = MutationDataType | undefined;

const onError = getErrorLoggerFunction('sendCableReelMail');

export const useSendCableReelMail = () => {
    const [response, setResponse] = useState<ResponseDataType>(undefined);

    const [sendCableReelMail, { loading, error, data }] = useMutation<MutationDataType, MutationSendCableReelMailArgs>(
        SEND_CABLE_REEL_MAIL,
        {
            onError
        }
    );

    const outgoingSendCableReelMail = useCallback(
        (cableReelMailInput: MutationSendCableReelMailArgs['cableReelMailInput']) => {
            sendCableReelMail({ variables: { cableReelMailInput } });
        },
        [sendCableReelMail]
    );

    useEffect(() => {
        if (data) {
            setResponse(data);
        }
    }, [data]);

    return {
        success: !!data,
        error: !!error,
        sendCableReelMail: outgoingSendCableReelMail,
        loading,
        response
    };
};
